/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserGraduate} from '@fortawesome/pro-duotone-svg-icons';

const GraduationIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUserGraduate} {...props} />
);

export default GraduationIcon;
